import React from 'react';
import { Loader } from 'freemium-ui';
import { Center } from '../../../shared/styles';
import request from '../../../utils/request';

const FreshidLogout = () => {
  const doLogout = async () => {
    const response = await request('/logout', {}, 'POST');
    localStorage.clear();
    if (response?.redirect_url) {
      window.location.href = response.redirect_url;
    }
  };

  React.useEffect(() => {
    doLogout();
  }, []);

  return (
    <Center minHeight="calc(100vh - 150px)">
      <Loader />
    </Center>
  );
};

export default FreshidLogout;
